// msal-config.ts — RM-02, constitution §V
// Configuration MSAL pour Azure AD OIDC.
// Les tokens sont stockés en sessionStorage (jamais localStorage — constitution §V).

import type { Configuration, RedirectRequest } from "@azure/msal-browser";
import { LogLevel } from "@azure/msal-browser";

import { appConfig } from "@/config";

export const msalConfig: Configuration = {
  auth: {
    clientId: appConfig.msalClientId,
    authority: appConfig.msalAuthority,
    knownAuthorities: [appConfig.msalAuthority],
    redirectUri: appConfig.msalRedirectUri || window.location.origin,
    postLogoutRedirectUri: appConfig.msalRedirectUri || window.location.origin,
    // After processing the Azure AD redirect, MSAL by default tries to navigate
    // back to the URL that initiated the login. Disabling this prevents routing
    // edge cases that can cause redirect loops in SPAs.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      // Always verbose to diagnose production auth issues
      logLevel: LogLevel.Verbose,
    },
  },
};

// Scopes nécessaires pour appeler l'API backend
// VITE_MSAL_SCOPE doit valoir "api://<clientId>/API.Access" (configuré côté Entra ID)
export const apiScopes: string[] = [
  appConfig.msalScope || `${appConfig.msalClientId}/.default`,
];

// Request de login par défaut
export const loginRequest: RedirectRequest = {
  scopes: apiScopes,
};
